import FieldSet from '../../FieldSet';
import terminology from 'javascripts/terminology';
import { humanize } from 'inflected';

import { RecordTypeIcon } from './RecordTypeIcon';
import { Name } from './Name';
import { ReferenceNum } from './ReferenceNum';
import { Type } from './Type';
import { RecordTypeColoredIcon } from './RecordTypeColoredIcon';
import { SuccessMetric } from './SuccessMetric';

export class IdentityFieldSet extends FieldSet {
  get fieldDefinitions() {
    return [
      RecordTypeIcon,
      RecordTypeColoredIcon,
      Name,
      ReferenceNum,
      Type,
      SuccessMetric,
    ];
  }

  get title() {
    return `${humanize(terminology(this.terminologyName))} info`;
  }
}
